import React from "react";
import { Drawer, Box, Typography, Link, IconButton, Button } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import type { FC } from "react";
import { SettingsAccordion } from "./SettingsAccordion";
import { useStyles } from "./Settings.styles";
import type { ISettingsProps } from "./Settings.types";

export const Settings: FC<ISettingsProps> = (props) => {
  const { open, onClose, onConfirmCookies } = props;
  const classes = useStyles();

  const onConfirmHandler = () => {
    onConfirmCookies();
    onClose();
  };

  return (
    <Drawer anchor="left" open={open} onClose={onClose}>
      <Box className={classes.root}>
        <Box className={classes.closeBar}>
          <IconButton size="small" onClick={onClose}>
            <CloseIcon className={classes.closeIcon} />
          </IconButton>
        </Box>

        <Box className={classes.content}>
          <Typography variant="h2" className={classes.contentTitle}>
            Privacy Preference Center
          </Typography>
          <Typography variant="body1" className={classes.contentBody}>
            When you visit any website, it may store or retrieve information on your browser, mostly in the form of cookies. This
            information might be about you, your preferences or your device and is mostly used to make the site work as you expect it to.
            The information does not usually directly identify you, but it can give you a more personalized web experience. Because we
            respect your right to privacy, you can choose not to allow some types of cookies. Click on the different category headings to
            find out more and change our default settings. However, blocking some types of cookies may impact your experience of the site
            and the services we are able to offer.
          </Typography>
          <Link className={classes.contentMoreInformation} href="https://cookiepedia.co.uk/giving-consent-to-cookies" target="_blank">
            More information
          </Link>

          <Typography variant="h3" className={classes.contentTitle}>
            Manage Consent Preferences
          </Typography>
          <SettingsAccordion />
        </Box>

        <Box className={classes.confirmBar}>
          <Button className={classes.confirmButton} onClick={onConfirmHandler}>
            Accept All Cookies
          </Button>
          <Box className={classes.confirmLogo}>
            <Link target="_blank" href="https://www.onetrust.com/products/cookie-consent/">
              <img src="https://cdn.cookielaw.org/logos/static/poweredBy_ot_logo.svg"></img>
            </Link>
          </Box>
        </Box>
      </Box>
    </Drawer>
  );
};
